import { render, staticRenderFns } from "./DynamicFormBuilder.vue?vue&type=template&id=389dd766&"
import script from "./DynamicFormBuilder.vue?vue&type=script&lang=ts&"
export * from "./DynamicFormBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports